import React from 'react';
import PropTypes, { number } from 'prop-types';
import { ActionButton } from './ActionButton';

import styles from './paramsCard/paramsCard.module.scss';

export const ParamsCard = (props) => {
  const {
    className = '',
    title,
    list,
    actions,
    isActive,
    onClick,
    isBlue,
    subContent,
    isSubContentOpen,
    counts,
    campaignsCounts,
    onCountsClick,
  } = props;

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const classNames = [styles.card];
  if (isActive) {
    classNames.push('_active');
  }
  if (subContent && isSubContentOpen) {
    classNames.push('_sub-content');
  }
  if (isBlue) {
    classNames.push('_blue');
  }
  if (className) {
    classNames.push(className);
  }

  return (
    <div className={classNames.join(' ')}>
      {actions && <ActionButton className={styles.menu} actions={actions} />}
      <div className={`${styles.wrapper} ${campaignsCounts ? styles.wrapperWithCampaignsCounts : ''}`} onClick={handleOnClick}>
        <header className={styles.header}>
          <h4 className={styles.title}>{title}</h4>
          {(counts || campaignsCounts) && (<div onClick={onCountsClick || null}>
            {counts && (
              <div className={styles.countsContainer}>
                <div className={styles.countsItem}>
                  <div className={`${styles.countsIcon} ${styles.countsIconGreen}`} />
                  <span className={styles.countsText}>{counts.whitelist}</span>
                </div>
                <div className={styles.countsItem}>
                  <div className={`${styles.countsIcon} ${styles.countsIconRed}`} />
                  <span className={styles.countsText}>{counts.blacklist}</span>
                </div>
              </div>
            )}
            {!counts && campaignsCounts && (
              <div className={`${styles.campaignCountsContainer}`}>
                <div className={`${styles.campaignCountsItem} ${styles.campaignCountsPaused}`}>
                  {(campaignsCounts.paused || 0) + (campaignsCounts.pending || 0)}
                </div>
                <div className={`${styles.campaignCountsItem} ${styles.campaignCountsRunning}`}>
                  {campaignsCounts.running || 0}
                </div>
                <div className={`${styles.campaignCountsItem} ${styles.campaignCountsExpired}`}>
                  {campaignsCounts.expired || 0}
                </div>
              </div>
            )}
          </div>)}
        </header>
        <ul className={styles.list}>
          {list.map((i, k) => (
            <li
              className={styles.item}
              key={typeof i.label === 'string' ? i.label : k}
              style={{ minWidth: `${100 / list.length}%` }}
            >
              <span className={styles.value}>{i.value}</span>
              <span className={styles.label}>{i.label}</span>
            </li>
          ))}
        </ul>
      </div>
      {subContent && isSubContentOpen && <div className={styles.subContent}>{subContent}</div>}
    </div>
  );
};

ParamsCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
    }),
  ).isRequired,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  actions: PropTypes.array,
  isBlue: PropTypes.bool,
  subContent: PropTypes.element,
  isSubContentOpen: PropTypes.bool,
  counts: PropTypes.shape({
    whitelist: number,
    blacklist: number,
  }),
  campaignsCounts: PropTypes.shape({
    paused: number,
    pending: number,
    running: number,
    expired: number,
  }),
  onCountsClick: PropTypes.func,
};
